export enum EAggregationDataKeys {
	FederalLevel = 'federal-aggregation',
	QuarterLevel = 'quarter-aggregation',
	InstitutionLevel = 'institution-aggregation',
	EntityLevel = 'entity-aggregation',
	ProgramLevel = 'program-aggregation',
}
